import { VChip } from 'vuetify/lib/components/VChip';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VChip,{attrs:{"small":"","color":_vm.color}},[_vm._v(_vm._s(_vm.$t(`labels.${_vm.status}`)))])
}
var staticRenderFns = []

export { render, staticRenderFns }